/*
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.exceptionDetailDialog = new ExceptionDetailDialog();
        }
*/
import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { GenericEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/GenericEvaluator";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceItemRetryPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceItemRetryProperties = {
    [name in keyof EntityCommandProcessInstanceItemRetryPropertyValues]: Property<EntityCommandProcessInstanceItemRetryPropertyValues[name]>
};

export interface IEntityCommandProcessInstanceItemRetry extends IEntityCommand, EntityCommandProcessInstanceItemRetryProperties
{
}

export class EntityCommandProcessInstanceItemRetry extends EntityCommand implements IEntityCommandProcessInstanceItemRetry
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceItemRetry";
    public static override className = "EntityCommandProcessInstanceItemRetry";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceItemRetryPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Retry",
                entityName: "ProcessInstanceItem",
                key: "RETRY",
                permission: PermissionEvaluator.permissionLevels.update,
                type: EntityCommandTypeEnum.entity,
                visibleEvaluator: new GenericEvaluator({
                    evaluateFn: (_, state) =>
                    {
                        if (!(state instanceof EntityCommandInformation))
                            return false;

                        const
                            status = state.record.get()?.statusLookupItem?.description;

                        switch (status)
                        {
                            case "Initialization Failed":
                            case "Execution Failed":
                            case "Completion Failed":
                                return true;
                        }

                        return false;
                    }
                }),
            }
        };
    }
    public static override getRequiredFields()
    {
        return [
            ...super.getRequiredFields(),
            "statusLookupItem.description",
        ];
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceItemRetryPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        ServiceManager.getRequired(WebApiClientService)
                            .createApiMethodRequest("DataService", "CallDataService", { id: "b185975f-0e14-4944-b706-6353f0d67dc4", operation: "RetryProcessInstanceItem", data: ObjectHelper.toJson({ processInstanceItemId: recordId }) })
                            .executeAsync()
                    );
                })
        );
    }

    // #endregion

    // #endregion
    }

